import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appTylkoLiczbyZmiennoprzecinkowe]'
})
export class TylkoLiczbyZmiennoprzecinkoweDirective {

  public text;

  private regex: RegExp = new RegExp(/^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:(\.)\d+)?$/);
  private specialKeys: Array<string> = ['Backspace', 'Tab', '.'];

  constructor(private el: ElementRef) {
  }


  @HostListener('keypress', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(event.key);

    if ((next && !String(next).match(this.regex))) {
      event.preventDefault();
    }
  }



}
